import React, { FC } from 'react';

import { TDataSet } from '../types';

type TPrepaidLatestVisitModal = {
  dataset: TDataSet;
  removeModal: () => void;
};

const PrepaidLatestVisitModal: FC<TPrepaidLatestVisitModal> = ({ dataset, removeModal }) => {
  const { onAccept, onReject } = dataset;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
      <p style={{ padding: 0, margin: 0, textAlign: 'center' }}>
        この記録は、直近の受診履歴ではありません。この受診履歴にチケット番号を適用しますか？
        <br />
        <br />
        <span style={{ color: 'var(--color-cerulean)' }}>※現在入力されているチケットは削除されます。</span>
      </p>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <button
          className='btn btn--additional'
          type='button'
          onClick={() => {
            if (onAccept) onAccept();
            removeModal();
          }}
        >
          はい
        </button>
        <button
          className='btn btn--main'
          type='button'
          onClick={() => {
            if (onReject) onReject();
            removeModal();
          }}
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default PrepaidLatestVisitModal;
